export function init_share_popup() {
    // share-popup
    var elms = document.querySelectorAll(".js-share-popup");
    [].forEach.call(elms, function (elm) {
        elm.addEventListener("click", function (e) {
            var target = event.target; // target can be inner element, svg etc. -> have to find link element
            while (target) {
                if (target.tagName.toLowerCase() === "a") {
                    window.open(target.getAttribute("href"), "_blank", "status=1,width=650,height=400,resizable=1");

                    e.preventDefault();
                    return false;
                }
                target = target.parentNode;
            }
        });
    });
}
